import React from 'react'
import { useTranslation } from 'next-i18next'
import { ConsumerPage } from '../../model'

import { Head } from '../../component'
import { CreatePasswordVerify } from '../../component/CreatePasswordVerify/CreatePasswordVerify'
import { TrackPageViewed } from '../../integrations/amplitude'

export const CreatePasswordVerifyPage: ConsumerPage = () => {
  const { t } = useTranslation()

  const pageTitle = `${t('common:brandName')}`

  return (
    <>
      <Head title={pageTitle} />
      <TrackPageViewed />
      <CreatePasswordVerify />
    </>
  )
}
